import React from 'react';
import styled from '@emotion/styled';

const IconWrapper = styled.div`
  color: #ffa800;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1rem;
  width: 1rem;
`;

const Svg = styled.svg`
  width: 0.625rem;
  height: 0.625rem;
`;

const SortIndicatorDownIcon = () => {
  return (
    <IconWrapper>
      <Svg viewBox="0 0 10.004 13.019">
        <path
          d="M699.583,1199.925a.99.99,0,0,0-1.461,0l-2.2,2.341v-8.177a1.035,1.035,0,1,0-2.066,0v8.178l-2.206-2.341a.99.99,0,0,0-1.461,0,1.145,1.145,0,0,0,0,1.551l3.97,4.214a1.033,1.033,0,0,0,.335.236.963.963,0,0,0,.79,0,1.035,1.035,0,0,0,.335-.236l3.968-4.214A1.145,1.145,0,0,0,699.583,1199.925Z"
          transform="translate(-689.882 -1192.992)"
          fill="#4694ce"
        />
      </Svg>
    </IconWrapper>
  );
};

export default SortIndicatorDownIcon;
